import { notificationConstants } from "../_constants";

export const notificationListRequest = (payload) => {
  return {
    type: notificationConstants.NOTIFICATION_LIST_REQUEST,
    payload,
  };
};

export const notificationListComplete = (payload) => {
  return {
    type: notificationConstants.NOTIFICATION_LIST_COMPLETE,
    payload,
  };
};

export const notificationListError = (payload) => {
  return {
    type: notificationConstants.NOTIFICATION_LIST_ERROR,
    payload,
  };
};
export const notificationListClear = () => {
  return {
    type: notificationConstants.NOTIFICATION_LIST_CLEAR,
  };
};

export const notificationDetailRequest = (payload) => {
  return {
    type: notificationConstants.NOTIFICATION_DETAIL_REQUEST,
    payload,
  };
};

export const notificationDetailComplete = (payload) => {
  return {
    type: notificationConstants.NOTIFICATION_DETAIL_COMPLETE,
    payload,
  };
};

export const notificationDetailError = (payload) => {
  return {
    type: notificationConstants.NOTIFICATION_DETAIL_ERROR,
    payload,
  };
};

export const notificationDetailClear = () => {
  return {
    type: notificationConstants.SET_NOTIFICATION_DETAIL_CLEAR,
  };
};

export const notificationUpdateRequest = (payload) => {
  return {
    type: notificationConstants.NOTIFICATION_UPDATE_REQUEST,
    payload,
  };
};

export const notificationUpdateComplete = (payload) => {
  return {
    type: notificationConstants.NOTIFICATION_UPDATE_COMPLETE,
    payload,
  };
};

export const notificationUpdateError = (payload) => {
  return {
    type: notificationConstants.NOTIFICATION_UPDATE_ERROR,
    payload,
  };
};

export const notificationUnreadCountRequest = (payload) => {
  return {
    type: notificationConstants.NOTIFICATION_UNREAD_COUNT_REQUEST,
    payload,
  };
};

export const notificationUnreadCountComplete = (payload) => {
  return {
    type: notificationConstants.NOTIFICATION_UNREAD_COUNT_COMPLETE,
    payload,
  };
};

export const notificationUnreadCountError = (payload) => {
  return {
    type: notificationConstants.NOTIFICATION_UNREAD_COUNT_ERROR,
    payload,
  };
};

export const notificationClearDetailObject = (payload) => {
  return {
    type: notificationConstants.NOTIFICATION_CLEAR_DETAIL_OBJ,
    payload,
  };
};

export const setIsPaginatingNotifications = (payload) => {
  return {
    type: notificationConstants.SET_IS_PAGINATING_NOTIFICATIONS,
    payload,
  };
};

export const clearNotificationDetailError = (payload) => {
  return {
    type: notificationConstants.CLEAR_NOTIFICATION_DETAIL_ERROR,
    payload,
  };
};
